import SelectBox, { ISelectBoxOptions } from "devextreme-react/select-box";
import BaseControlProps from "../../../interfaces/BaseControlProps";
import "./styles/Controls.css";

export default function PromineoGridDropdown(props: ISelectBoxOptions & BaseControlProps) {
  const { className, size, radiusSize, ...rest } = props;

  const getClassNames = () => {
    const defaultClassNames = "promineo-gridDropdown h-6 rounded";
    return className ? `${defaultClassNames} ${className}` : defaultClassNames;
  };

  const DropdownButton = () => {
    return (
      <div className="icon dx-icon-chevrondown mt-1"></div>
    );
  };

  return (
    <SelectBox
      dropDownButtonRender={DropdownButton}
      className={getClassNames()}
      {...rest}
    />
  );
}